import { FaWhatsapp } from "react-icons/fa";
import { useState } from "react";

const QuickOrderModal = ({ open, onClose, product, selectedSize, quantity }) => {
 
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    street: "",
    home: "",
    area: "",
    state: "",
    pincode: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  if (!open) return null; // Conditional render comes AFTER hooks

  const whatsappNumber = "919834704067";

  const handleOrder = () => {
    if (!formData.name || !formData.mobile || !formData.street) {
      alert("Please fill in all required fields: Name, Mobile, Street.");
      return;
    }

    const text = `Hello,

I want to place an order.

Product: ${product.name}
Size: ${selectedSize}
Quantity: ${quantity}

Name: ${formData.name}
Mobile: ${formData.mobile}
Street: ${formData.street}
Home: ${formData.home || "-"}
Area: ${formData.area || "-"}
State: ${formData.state || "-"}
Pincode: ${formData.pincode || "-"}

Link: ${window.location.href}

Please confirm availability.`;

    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
  className="bg-white rounded-lg w-full max-w-md max-h-[90vh] overflow-y-auto p-6 scrollbar-hide"
  onClick={(e) => e.stopPropagation()}
>
        <h2 className="text-lg font-semibold mb-4">Confirm Order</h2>

        {/* Product Summary */}
        <div className="mb-4 p-3 bg-gray-50 rounded">
          <p className="font-medium">{product.name}</p>
          <p>Size: {selectedSize}</p>
          <p>Quantity: {quantity}</p>
        </div>

        {/* Form */}
        <form className="space-y-3">
          <div>
            <label className="block text-sm font-medium">Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Full Name"
              className="w-full border rounded px-3 py-1 focus:outline-none focus:ring-2 focus:ring-black"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium">Mobile *</label>
            <input
              type="tel"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Mobile Number"
              className="w-full border rounded px-3 py-1 focus:outline-none focus:ring-2 focus:ring-black"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium">Street *</label>
            <input
              type="text"
              name="street"
              value={formData.street}
              onChange={handleChange}
              placeholder="Street Name, Building, etc."
              className="w-full border rounded px-3 py-1 focus:outline-none focus:ring-2 focus:ring-black"
              required
            />
          </div>

          {/* Optional Fields */}
          <div>
            <label className="block text-sm font-medium text-gray-500">Home/Apartment</label>
            <input
              type="text"
              name="home"
              value={formData.home}
              onChange={handleChange}
              placeholder="Optional"
              className="w-full border rounded px-3 py-1 focus:outline-none focus:ring-2 focus:ring-black"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-500">Area/Locality</label>
            <input
              type="text"
              name="area"
              value={formData.area}
              onChange={handleChange}
              placeholder="Optional"
              className="w-full border rounded px-3 py-1 focus:outline-none focus:ring-2 focus:ring-black"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-500">State</label>
            <input
              type="text"
              name="state"
              value={formData.state}
              onChange={handleChange}
              placeholder="Optional"
              className="w-full border rounded px-3 py-1 focus:outline-none focus:ring-2 focus:ring-black"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-500">Pincode</label>
            <input
              type="text"
              name="pincode"
              value={formData.pincode}
              onChange={handleChange}
              placeholder="Optional"
              className="w-full border rounded px-3 py-1 focus:outline-none focus:ring-2 focus:ring-black"
            />
          </div>

          <button
            type="button"
            onClick={handleOrder}
            className="w-full bg-black text-white py-1 mt-2 rounded flex items-center justify-center gap-2 hover:bg-gray-800 transition"
          >
            <FaWhatsapp /> Confirm Order via WhatsApp
          </button>
        </form>
      </div>
    </div>
  );
};

export default QuickOrderModal;